import Create from "./Create";
import List from "./List";
import Update from "./Update";

export const EventClassification = {
  List: List,
  Update: Update,
  Create: Create,
  Permissions: {
    list: "list:Event",
    create: "create:Event",
    read: "read:Event",
    update: "update:Event",
    delete: "delete:Event",
  },
};
